import React from 'react'
import { Router } from '@reach/router'
import { LoadingSpinner } from '@paypalcorp/pp-react'
import { Logger as clientLogger, LOG_LEVEL } from 'beaver-logger'
import { initialize as fptiInitialize } from './lib/fpti-analytics'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import ppEnv from 'environment-paypal'
import { PAYPAL_THEME } from '@paypalcorp/pp-react-theme'
import { ThemeProvider, CacheProvider } from '@emotion/react'
import createCache from '@emotion/cache'

const AppDownload = React.lazy(() => import('./screens/app-download'))
const DonePage = React.lazy(() => import('./screens/done-page'))
const WelcomeOfferLandingPage = React.lazy(() =>
  import('./screens/offers/welcome'),
)
const EmailComplete = React.lazy(() =>
  import('./screens/welcome-back/email-complete'),
)
const Referee = React.lazy(() => import('./screens/mgm/referee'))
const Referrer = React.lazy(() => import('./screens/mgm/referrer'))

const logger = clientLogger({
  url: '/cgp/log',
  // Log level to display in the browser console (only in dev)
  logLevel:
    ppEnv.isProd() || process.env.NODE_ENV === 'production'
      ? LOG_LEVEL.WARN
      : LOG_LEVEL.DEBUG,
})

const cacheObj = createCache({
  key: 'gnw',
  prepend: true,
})

function App({ serverData }) {
  fptiInitialize()
  logger.info('CLIENT', {
    m_flow: serverData.flowName || '',
    m_intent: serverData.intent || '',
    m_src: serverData.downloadSource || '',
    m_tsrce: serverData.trafficSource || '',
    m_browser: get(serverData, 'deviceDetails.browserName', ''),
    m_browser_version: get(serverData, 'deviceDetails.browserVersion', ''),
    m_device_os: get(serverData, 'deviceDetails.deviceOS', ''),
    m_device_os_version: get(serverData, 'deviceDetails.deviceOSVersion', ''),
    m_device_type: get(serverData, 'deviceDetails.deviceType', ''),
    message: 'Loading App component',
  }) //client side logging

  return (
    <CacheProvider value={cacheObj}>
      <ThemeProvider theme={PAYPAL_THEME}>
        <div data-testid="app-container">
          <React.Suspense
            fallback={
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  minHeight: '100vh',
                }}
              >
                <LoadingSpinner screenReaderText="loading" size="xl" />
              </div>
            }
          >
            <Router>
              <AppDownload path="/app-download" serverData={serverData} />
              <AppDownload path="/flow/app-download" serverData={serverData} />
              <AppDownload
                path="/public/flow/app-download"
                serverData={serverData}
              />
              <AppDownload
                path="/public/app-download"
                serverData={serverData}
              />
              <DonePage path="/done-page" serverData={serverData} />
              <WelcomeOfferLandingPage
                path="/offer/welcome"
                serverData={serverData}
              />
              <EmailComplete
                path="/welcome-back/email-complete"
                serverData={serverData}
              />
              <Referee path="/mgm/referee" serverData={serverData} />
              <Referrer path="/mgm/referrer" serverData={serverData} />
            </Router>
          </React.Suspense>
        </div>
      </ThemeProvider>
    </CacheProvider>
  )
}

App.propTypes = {
  serverData: PropTypes.object,
}

export default App
